import { OfferResponseWithStatus } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

export class OfferService {
    public static getCurrentBroadbandOffer(
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
    ): Promise<OfferResponseWithStatus> {
        return api.offerController.getCustomerBroadbandOffer(partnerId, { billingAccountId, servicePointId });
    }
}
